import { Icon, InfoCircleHollowSVG, Button } from "@newsela/angelou";
import { actionNames, withTrackEvent } from "@newsela/snitch";
import { VIEW_PAGE_LUNA_AI_DESIGN } from "@/ai/constants/experiments";
import AILunaTag from "@/components/AIComponents/AILunaTag/AILunaTag";
import useHasFeature from "@/features/useHasFeature";
import PanelHeader from "@/view/PanelHeader";
import {
  infoIconCss,
  headerItemsCss,
  betaTagCss,
  teacherHeaderCss,
} from "./GuidedHighlightingPanelHeader.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

interface IGuidedHighlightingPanelHeaderProps {
  isStudent: boolean;
  onClickBackButton: () => void;
  onClickCloseButton: () => void;
  closeButtonEventProperties: React.HTMLAttributes<HTMLButtonElement>;
  backButtonEventProperties: {
    objectType: string;
    actionName: string;
    streamProperties: {
      content_type: string;
      description: string;
      content_id: string | string[] | undefined;
    };
  };
  activateGuidedHighlightingPopup: () => void;
  shouldFocusCloseButtonRef: object;
}

const GuidedHighlightingPanelHeader = ({
  isStudent,
  onClickBackButton,
  onClickCloseButton,
  closeButtonEventProperties,
  backButtonEventProperties,
  activateGuidedHighlightingPopup,
  shouldFocusCloseButtonRef,
}: IGuidedHighlightingPanelHeaderProps) => {
  const [showLunaAiBranding] = useHasFeature(VIEW_PAGE_LUNA_AI_DESIGN);

  return (
    <PanelHeader
      onClickBackButton={onClickBackButton}
      onClickCloseButton={onClickCloseButton}
      closeButtonEventProperties={closeButtonEventProperties}
      backButtonEventProperties={backButtonEventProperties}
      shouldFocusCloseButtonRef={shouldFocusCloseButtonRef}
    >
      {isStudent ? (
        <div css={headerItemsCss}>
          <h3>Guided Highlighting</h3>
          {/* @ts-expect-error Property 'children' does not exist on type */}
          <ButtonWithTrackEvent
            flavor={Button.flavors.incognito}
            onClick={() => activateGuidedHighlightingPopup()}
            // objectType={ need to create a guidedHighlighting type}
            actionName={actionNames.interact}
            key={"guided-highlighting-info-button"}
          >
            <Icon
              dataProps={{ "data-testid": "guided-highlighting-info-button" }}
              SvgComponent={InfoCircleHollowSVG}
              __cssFor={{ root: infoIconCss }}
            />
          </ButtonWithTrackEvent>
        </div>
      ) : (
        <div css={teacherHeaderCss}>
          <h3>Guided Highlighting</h3>
          {showLunaAiBranding ? (
            <AILunaTag />
          ) : (
            <span css={betaTagCss}>Beta</span>
          )}
        </div>
      )}
    </PanelHeader>
  );
};

export default GuidedHighlightingPanelHeader;
